import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { Provider  } from 'react-redux';
import { store } from './store';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { restoreSession } from './store/modules/user';

dayjs.locale('zh-cn');
store.dispatch(restoreSession());

const root = ReactDOM.createRoot(document.getElementById('root'));

// 根据环境决定是否使用 StrictMode
// 开发环境：不使用 StrictMode，避免双重渲染和重复请求
// 生产环境：使用 StrictMode，帮助发现潜在问题
const isDevelopment = process.env.NODE_ENV === 'development';
const antdTheme = {
  token: {
    fontSize: 12,
    fontSizeLG: 14,
    fontSizeSM: 11,
    controlHeight: 30,
    controlHeightLG: 36,
    controlHeightSM: 24,
    borderRadius: 7,
    padding: 12,
    paddingLG: 16,
    paddingSM: 8,
    margin: 12,
    marginLG: 16,
    marginSM: 8,
  },
  components: {
    Button: {
      controlHeight: 30,
      controlHeightLG: 36,
      controlHeightSM: 24,
      paddingInline: 12,
      paddingInlineLG: 14,
      paddingInlineSM: 8,
    },
    DatePicker: {
      controlHeight: 30,
      controlHeightLG: 36,
      controlHeightSM: 24,
    },
    Form: {
      itemMarginBottom: 14,
      labelFontSize: 12,
    },
    Input: {
      controlHeight: 30,
      controlHeightLG: 36,
      controlHeightSM: 24,
      paddingBlock: 4,
      paddingBlockLG: 6,
      paddingBlockSM: 2,
      paddingInline: 10,
    },
    Modal: {
      titleFontSize: 14,
      paddingContentHorizontalLG: 20,
      paddingContentVerticalLG: 16,
    },
    Select: {
      controlHeight: 30,
      controlHeightLG: 36,
      controlHeightSM: 24,
    },
    Table: {
      cellFontSize: 12,
      headerSplitColor: '#dbe4f2',
      cellPaddingBlock: 5,
      cellPaddingInline: 8,
      cellPaddingBlockMD: 5,
      cellPaddingInlineMD: 8,
      cellPaddingBlockSM: 3,
      cellPaddingInlineSM: 8,
      headerBorderRadius: 8,
    },
    Tabs: {
      horizontalItemPadding: '8px 0',
      titleFontSize: 12,
    },
  },
};

root.render(
  isDevelopment ? (
    <ConfigProvider locale={zhCN} theme={antdTheme}>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ConfigProvider>
  ) : (
    <React.StrictMode>
      <ConfigProvider locale={zhCN} theme={antdTheme}>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </ConfigProvider>
    </React.StrictMode>
  )
);
